
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAYYV_33K3mXmNP6-VzwOia9OIarQqYrjg",
  authDomain: "watercrm.firebaseapp.com",
  projectId:"watercrm",
  storageBucket: "watercrm.firebasestorage.app",
  messagingSenderId:"919125815470",
  appId: "1:919125815470:web:8dffa768c42938e0b43d3f",
  measurementId:'G-CY5H9QLDPE'
};
const firebaseApp = initializeApp(firebaseConfig);
export const getFirebaseMessaging = async () => {
  const supported = await isSupported();
  if (!supported) {
    console.warn("🚫 Push messaging not supported in this browser.");
    return null;
  }
  return getMessaging(firebaseApp);
};

// export { messaging};


